<template>
  <div class="schedule">
    <div
      class="slot"
      v-for="(hour, index) in schedule[currentDay]"
      :key="hour + index"
      :class="[getBackgroundClass(hour, index)]"
    >
      <div
        v-if="currentHour === index"
        class="currentSlot"
        :style="{ left: `${currentMinutes}px` }"
      />

      <div v-if="index === currentHour" class="mark currentMark">
        <div>
          <p>•</p>
          <p>{{ `${currentHour}:${currentMinutes}` }}</p>
        </div>
      </div>

      <div v-else-if="index === 0" class="mark">
        <div>
          <p>•</p>
          <p>00:00</p>
        </div>
      </div>
      <div v-else-if="index === 12" class="mark">
        <div>
          <p>•</p>
          <p>12:00</p>
        </div>
      </div>
      <div v-else-if="index === 23" class="mark">
        <div>
          <p>•</p>
          <p>23:00</p>
        </div>
      </div>
      <div v-else class="mark">
        <div>
          <p>∙</p>
          <p>&nbsp;</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as timezones from "@/util/timezones.json";
import moment from "moment-timezone";
import { mapState } from "vuex";
import constants from "@/config/constants";

export default {
  name: "device-schedule",
  props: {
    schedule: {
      type: Array,
      required: true,
    },
    isPowerOn: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    let tz = timezones.default.find(
      (tz) => tz.value === this.$store.state.installations.current.timeZoneId
    );

    if (!tz) {
      let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      timezones.default.every((ti) => {
        let myUtc = ti.utc.find((utc) => utc === timezone);
        if (myUtc) {
          tz = ti;
          return false;
        }
        return true;
      });
    }

    let date = moment.utc().tz(tz.utc[0]);

    const minutes = date.minutes();

    return {
      currentDay: date.day() > 0 ? date.day() - 1 : 6,
      currentHour: date.hour(),
      currentMinutes: minutes <= 9 ? `0${minutes}` : minutes,
    };
  },

  computed: {
    ...mapState("devices", {
      device: "current",
    }),
  },

  methods: {
    getBackgroundClass: function (hour) {
      let ecoBackground = false;
      let ecoBackgroundGrayscale = false;
      let warmBackground = false;
      let warmBackgroundGrayscale = false;
      let coldBackground = false;
      let offBackground = false;
      let offBackgroundGrayscale = false;

      const power = this.device.data.power;
      const isManual = this.device.data.mode === constants.modes.manual;

      switch (hour) {
        case "E":
          if (!power || isManual) ecoBackgroundGrayscale = true;
          else ecoBackground = true;
          break;
        case "C":
          if (!power || isManual) warmBackgroundGrayscale = true;
          else warmBackground = true;
          break;
        case "O":
          if (!power || isManual) offBackgroundGrayscale = true;
          else if (this.device.data.ice_mode) coldBackground = true;
          else offBackground = true;

          break;
      }

      return {
        ecoBackground: ecoBackground,
        ecoBackgroundGrayscale: ecoBackgroundGrayscale,
        warmBackground: warmBackground,
        warmBackgroundGrayscale: warmBackgroundGrayscale,
        coldBackground: coldBackground,
        offBackground: offBackground,
        offBackgroundGrayscale: offBackgroundGrayscale,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule {
  width: 100%;
  height: 4rem;
  display: flex;
}

.slot {
  flex: 1 1 0;
  width: 0;
  display: flex;
}

.currentSlot {
  position: relative;
  background-color: white;
  width: 4px;
  height: 4rem;
}

.mark {
  display: inline-block;
  position: relative;
  top: 4.5rem;
  width: 100%;
  color: rgba(0, 0, 0, 0.5);
}

@media screen and (max-width: 1087px) {
  .scheduleContainer {
    width: 100%;
  }
}
</style>
